module.exports = __webpack_public_path__ + "img/banner-about.b1c72df0.jpeg";